import apiClient from './apiClient';

const normalizeFramework = (f) => ({ ...f, controls: (f?.controls || []).map((c) => ({ ...c, status: String(c?.status || 'PARTIAL').toLowerCase() })) });
const toControlPayload = (p) => ({ ...p, ...(p.status != null && { status: String(p.status).toUpperCase() }) });

export async function fetchComplianceFrameworks() {
  const { data } = await apiClient.get('/compliance/frameworks');
  return data.map(normalizeFramework);
}

export async function patchComplianceControl(id, changes) {
  const { data } = await apiClient.patch(`/compliance/controls/${id}`, toControlPayload(changes));
  return { ...data, status: String(data?.status || 'PARTIAL').toLowerCase() };
}

export async function createComplianceFramework(payload) {
  const { data } = await apiClient.post('/compliance/frameworks', payload);
  return normalizeFramework(data);
}

export async function createComplianceControl(frameworkId, payload) {
  const { data } = await apiClient.post(`/compliance/frameworks/${frameworkId}/controls`, payload);
  return { ...data, status: String(data?.status || 'PARTIAL').toLowerCase() };
}
